import { getLocale } from "../runtime";

const sv_articles = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Artiklar`
};

const articles = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_articles(inputs)
	return "articles";
};

export { articles as "articles" };